import { makeStyles } from '@material-ui/core';
import { scienceBlue, silver, onHoverBackground } from '../../../abstracts/colours';

export const useStyles = makeStyles({
  root: {
    '&, $span': {
      color: scienceBlue,
    },

    '&.MuiRadio-root': {
      '&:hover': {
        backgroundColor: onHoverBackground,
      },
    },

    '&.Mui-disabled': {
      '&, $span': {
        color: silver,
      },
    },
  },
});
